/**
 * product-form + quantity-input for PDP revamp/classic ATC on Aqua (hdt-cart-drawer).
 */
(function () {
  'use strict';

  function getCartDrawer() {
    return (
      document.querySelector('hdt-cart-drawer#CartDrawer') ||
      document.querySelector('hdt-cart-drawer') ||
      document.querySelector('cart-drawer')
    );
  }

  function openAquaCartDrawer() {
    var drawer = getCartDrawer();
    if (drawer && typeof drawer.openDialog === 'function') {
      drawer.openDialog();
      return true;
    }
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }
    var cartBtn =
      document.querySelector('#cart-icon-bubble[aria-controls="CartDrawer"]') ||
      document.querySelector('[aria-controls="CartDrawer"]');
    if (cartBtn) {
      cartBtn.click();
      return true;
    }
    return false;
  }

  function collectCartSections() {
    var sections = [];
    document.dispatchEvent(
      new CustomEvent('cart:push:section.id', {
        bubbles: true,
        detail: { sections: sections },
      })
    );
    return sections;
  }

  function createCartPromise() {
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', {
      headers: { Accept: 'application/json' },
    }).then(function (r) {
      return r.json();
    });
  }

  function refreshCartUI(cart, actionAfterATC) {
    document.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'variant:add',
          actionAfterATC: actionAfterATC,
          cart: cart,
        },
      })
    );
    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { item_count: cart && cart.item_count },
      })
    );
  }

  if (!customElements.get('quantity-input')) {
    customElements.define(
      'quantity-input',
      class QuantityInput extends HTMLElement {
        constructor() {
          super();
          this.input = this.querySelector('input');
          this.changeEvent = new Event('change', { bubbles: true });
          this.querySelectorAll('button').forEach(function (button) {
            button.addEventListener('click', this.onButtonClick.bind(this));
          }, this);
        }

        onButtonClick(event) {
          event.preventDefault();
          var previousValue = this.input.value;
          if (event.target.name === 'plus' || event.currentTarget.name === 'plus') {
            this.input.stepUp();
          } else {
            this.input.stepDown();
          }
          if (previousValue !== this.input.value) {
            this.input.dispatchEvent(this.changeEvent);
          }
          // Blur so mobile focus styles don't leave icon-font glyphs unpainted
          if (event.currentTarget && typeof event.currentTarget.blur === 'function') {
            event.currentTarget.blur();
          }
        }
      }
    );
  }

  if (!customElements.get('product-form')) {
    customElements.define(
      'product-form',
      class ProductForm extends HTMLElement {
        constructor() {
          super();
          this.form = this.querySelector('form');
          if (!this.form) return;

          var idInput = this.form.querySelector('[name=id]');
          if (idInput) idInput.disabled = false;

          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          this.submitButton = this.querySelector('[type="submit"]');
          if (getCartDrawer() && this.submitButton) {
            this.submitButton.setAttribute('aria-haspopup', 'dialog');
          }
        }

        onSubmitHandler(evt) {
          evt.preventDefault();
          if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') {
            return;
          }

          this.handleErrorMessage();
          this.submitButton.setAttribute('aria-disabled', 'true');
          this.submitButton.classList.add('loading');
          var spinner = this.querySelector('.loading-overlay__spinner');
          if (spinner) spinner.classList.remove('hidden');
          if (window.Shopify && typeof Shopify.setPdpAtcLoading === 'function') {
            Shopify.setPdpAtcLoading(true);
          }

          var formData = new FormData(this.form);
          var sections = collectCartSections();
          if (sections.length) {
            formData.set('sections', sections.join(','));
          }

          var root =
            (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          var addUrl = root + 'cart/add.js';

          var self = this;
          fetch(addUrl, {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              Accept: 'application/javascript',
            },
            body: formData,
          })
            .then(function (response) {
              return response.json().then(function (data) {
                return { ok: response.ok, data: data };
              });
            })
            .then(function (result) {
              if (!result.ok || result.data.status) {
                self.handleErrorMessage(
                  result.data.description || result.data.message || 'Could not add to cart'
                );
                self.error = true;
                return null;
              }

              self.error = false;

              document.dispatchEvent(
                new CustomEvent('variant:add', {
                  bubbles: true,
                  detail: {
                    items: result.data.items || [result.data],
                    cart: result.data,
                    actionAfterATC: 'no',
                  },
                })
              );

              if (
                window.Shopify &&
                (Shopify._pendingCartDrawerOpen ||
                  Shopify._cartDrawerUpdatedFromAdd ||
                  (typeof Shopify.hasOpenedDrawerForCurrentAdd === 'function' &&
                    Shopify.hasOpenedDrawerForCurrentAdd()))
              ) {
                return null;
              }

              return createCartPromise().then(function (cart) {
                cart.sections = result.data.sections || {};
                refreshCartUI(cart, 'no');
                if (window.Shopify && typeof Shopify.queueCartDrawerOpen === 'function') {
                  Shopify.queueCartDrawerOpen();
                }
              });
            })
            .catch(function (e) {
              console.error(e);
              self.error = true;
            })
            .finally(function () {
              if (self.error) {
                if (self.submitButton) {
                  self.submitButton.classList.remove('loading');
                  self.submitButton.removeAttribute('aria-disabled');
                }
                if (spinner) spinner.classList.add('hidden');
                if (window.Shopify && typeof Shopify.setPdpAtcLoading === 'function') {
                  Shopify.setPdpAtcLoading(false);
                }
              }
            });
        }

        handleErrorMessage(errorMessage) {
          this.errorMessageWrapper =
            this.errorMessageWrapper || this.querySelector('.pform-error-wrap');
          if (!this.errorMessageWrapper) return;
          this.errorMessage =
            this.errorMessage || this.errorMessageWrapper.querySelector('.pform-error-msg');
          this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
          if (errorMessage && this.errorMessage) {
            this.errorMessage.textContent = errorMessage;
          }
        }
      }
    );
  }
})();
